// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1r9iH","imageUploader":"EGiftCard_imageUploader__ujZoF"};